import { createFileRoute } from '@tanstack/react-router';

import { ProceedingBrowse } from '@/module/Author/Proceeding';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProceedingBrowse />;
}
